import { siteName } from "@/constants/config";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PrivacySection = (props: { title: string; description: string; img: string }) => {
  const { title, description, img } = props;
  return (
    <Box>
      <Typography
        variant={"h6"}
        color={""}
        gutterBottom
        sx={{
          fontWeight: "medium",
        }}
      >
        {title}
      </Typography>
      <Typography component={"p"} color={""}>
        {description}
      </Typography>
      <img src={img} className="block max-w-[100%] mt-[10px] mx-auto" alt="" />
    </Box>
  );
};

const Content = () => {
  const data = [
    {
      // title: "1. What information do we collect?",
      description:
        "Unlocking incredible award flight opportunities with American Express Membership Rewards points is a breeze, thanks to their remarkable versatility in the world of travel. In this comprehensive guide, we'll lead you through the seamless process of transferring your American Express Membership Rewards points to airline partners and leveraging them for unforgettable award flights.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.png",
    },
    {
      title: "1. Log in your Amex Membership Rewards account ",
      // description:
      // 'To initiate the point transfer process, you must first select the airline partner of your choice. American Express boasts a diverse array of airline partners, including esteemed carriers like Delta Airlines, Air Canada, Emirates, and more. To explore the complete list of American Express airline partners, simply log in to your Amex account and navigate to the Membership Rewards portal. Once there, click on the "Transfer Points" tab to access the full list of airline partners.',
      img: "https://img.awardtool.com/guides/Amex-1.png",
    },
    {
      title: "2. Choose Your Airline Partner",
      description:
        'To initiate the point transfer process, you must first select the airline partner of your choice. American Express boasts a diverse array of airline partners, including esteemed carriers like Delta Airlines, Air Canada, Emirates, and more. To explore the complete list of American Express airline partners, simply log in to your Amex account and navigate to the Membership Rewards portal. Once there, click on the "Transfer Points" tab to access the full list of airline partners.',
      img: "https://img.awardtool.com/guides/Amex-2.png",
    },
    {
      title: "3. Link Your Loyalty Accounts",
      description:
        "After choosing your preferred airline partner, the next crucial step is to link your loyalty accounts. This entails entering your frequent flyer number for the chosen airline partner, with most transfers occurring at a 1:1 ratio or more. Let's use Air France/KLM as an example. 		Amex will provide a dropdown menu with pertinent details about the airline and the timing for point transfers. While most transfers are instantaneous, some may take a few days, with Air Canada stating transfers could take up to 48 hours. Enter your frequent flyer account number. You may be prompted to verify your card for added security. Once completed, your Amex and Air France accounts will be successfully linked.",
      img: "https://img.awardtool.com/guides/Amex-3.png",
    },
    {
      title: "4. Transfer Your Points",
      description:
        "With your loyalty accounts linked, you're now ready to transfer your American Express Membership Rewards points to your airline partner. Simply input the number of points you wish to transfer and click \"Review Transfer.\" It's vital to note that all point transfers are irreversible, so careful review is essential.",
      img: "https://img.awardtool.com/guides/Amex-4.png",
    },
    {
      title: "5. Book Your Award Flight",
      description:
        "After successfully transferring your American Express Membership Rewards points to your airline partner, the final step is booking your coveted award flight. To do so, log in to your airline loyalty account and search for available award flights. To save time, consider utilizing " + siteName + ", a tool that enables you to search for award flights across major airline loyalty programs simultaneously, rather than visiting each airline's website individually.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.png",
    },
    {
      // title: "5. Is your information transferred internationally?",
      description:
        "Keep in mind that award flight availability can vary, so it's wise to begin your search well in advance of your intended travel date. For added assurance, confirm the availability of your desired award flight directly on the airline's website before initiating the transfer of your American Express Membership Rewards points. Remember, point transfers are irreversible, so meticulous planning is key.",
      // img: "https://img.awardtool.com/city_imgs/san_francisco.png",
    },
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
